import { resetAppState } from 'app/utils';
import Cookies from 'universal-cookie';

let isUserTOS = false;

const logout = () => {
  localStorage.removeItem('object');
  localStorage.removeItem('user');
  removeCookie();
  resetAppState();
  window.location.href = '/';
};

const setCookie = token => {
  const cookies = new Cookies();
  cookies.set(isUserTOS ? 'nic-tos' : 'nic-portal', token, { path: '/' });
};

const setLanguage = lang => {
  localStorage.setItem('lang', JSON.stringify(lang));
};

const removeCookie = () => {
  const cookies = new Cookies();
  cookies.remove(isUserTOS ? 'nic-tos' : 'nic-portal');
};

const setIsUserTOS = value => {
  isUserTOS = value;
};

export default {
  logout,
  setCookie,
  removeCookie,
  setIsUserTOS,
  setLanguage,
};
